// extracted by mini-css-extract-plugin
export var childrenContainer = "_d4-0";
export var virtualScrollArea = "_d4-1";